import { Component, Input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: "app-bp-overlay",
    imports: [TranslateModule],
    templateUrl: "./bp-overlay.component.html",
    styleUrl: "./bp-overlay.component.scss"
})
export class BpOverlayComponent {
  @Input() text: string = "";
}
